export default __webpack_public_path__ + "330ec4e8efcf7a9083107c513ac2e18d.wav";